/**
 * Capitalize the first letter of a string.
 * @param string
 * @returns
 * @example capitalize("hello, world!") // "Hello, world!"
 */
export const capitalize = (string: string): string => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};
export { camelCase, startCase } from 'lodash';

export function stripPreSlash(value: string): string {
	return value ? value.replace(/^\/+/g, '') : value;
}

export function stripTrailingSlash(s: string) {
	return s.endsWith('/') ? s.slice(0, -1) : s;
}
